"use client"

import { DashboardHeader } from "@/components/dashboard-header"
import { DashboardShell } from "@/components/dashboard-shell"
import { AdmittedPatientsList } from "@/components/admitted-patients-list"

export default function AdmittedPatientsPage() {
  return (
    <div className="md:ml-64">
      <DashboardShell>
        <DashboardHeader
          heading="In-Patient Management"
          text="Manage all currently admitted patients."
        />
        <AdmittedPatientsList />
      </DashboardShell>
    </div>
  )
} 